export class Client {
    i: string;
    n: string;
    c: string;
    r: string[];
    v: boolean;
    constructor(
        id: string,
        name: string,
        code: string,
        roadbook_ids: string[],
        visible: boolean
    ) {
        this.i = id;
        this.n = name;
        this.c = code;
        this.r = roadbook_ids;
        this.v = visible;
    }
}
